export const PR = {};

PR.VIEW_MRP_MODAL = "VIEW_MRP_MODAL";
PR.CLOSE_VIEW_MRP_MODAL = "CLOSE_VIEW_MRP_MODAL";
PR.GET_ORDERS_MODAL = "GET_ORDERS_MODAL";
PR.ADD_ORDERS_MODAL = "ADD_ORDERS_MODAL";
PR.CLOSE_ADD_ORDERS_MODAL = "CLOSE_ADD_ORDERS_MODAL";
PR.ADD_MATERIALS_MODAL = "ADD_MATERIALS_MODAL";
PR.CLOSE_ADD_MATERIAL_MODAL = "CLOSE_ADD_MATERIAL_MODAL";
PR.UPDATE_LIST_OF_MATERIALS = "UPDATE_LIST_OF_MATERIALS";
PR.UPDATE_LIST_OF_ORDERS = "UPDATE_LIST_OF_ORDERS";
PR.UPDATE_SELECTED_MATERIALS_LIST = "UPDATE_SELECTED_MATERIALS_LIST";
PR.RESET_CREATE_LIST_OF_MRP_STORE = "RESET_CREATE_LIST_OF_MRP_STORE";
PR.CONFIRM_CLOSE_ADD_MATERIAL_MODAL = "CONFIRM_CLOSE_ADD_MATERIAL_MODAL";

//------------
PR.UPDATE_WAITING_MRP_LIST_FOR_NEW_PR = "UPDATE_WAITING_MRP_LIST_FOR_NEW_PR";
PR.UPDATE_WAITING_MRP_LIST_FOR_CONFIRM_PR =
  "UPDATE_WAITING_MRP_LIST_FOR_CONFIRM_PR";
PR.UPDATE_WAITING_BADGE_COUNT = "UPDATE_WAITING_BADGE_COUNT";

PR.ADD_NOTE_MODAL = "ADD_NOTE_MODAL";
PR.REMOVE_NOTE = "REMOVE_NOTE";
PR.CLOSE_NOTE_MODAL = "CLOSE_NOTE_MODAL";
PR.CONFIRM_CLOSE_NOTE_MODAL = "CONFIRM_CLOSE_NOTE_MODAL";
PR.INITIAL_STATE_REGITER_PR_STORE = "INITIAL_STATE_REGITER_PR_STORE";

PR.CONFIRM_REJECT_MODAL = "CONFIRM_REJECT_MODAL";
PR.CLOSE_CONFIRM_REJECT_MODAL = "CLOSE_CONFIRM_REJECT_MODAL";
PR.CONFIRMCLOSE_CONFIRM_REJECT_MODAL = "CONFIRMCLOSE_CONFIRM_REJECT_MODAL";

PR.UPDATET_PR_LIST = "UPDATET_PR_LIST";
PR.UPDATE_DEFAULT_PR = "UPDATE_DEFAULT_PR";
PR.UPDATE_PR_DETAILS_INFO = "UPDATE_PR_DETAILS_INFO";
PR.UPDATE_PR_DETAILS_INFO_BY_DEFAULT = "UPDATE_PR_DETAILS_INFO_BY_DEFAULT";

PR.VIEW_DOC_MODAL = "VIEW_DOC_MODAL";
PR.CLOSE_VIEW_DOC_MODAL = "CLOSE_VIEW_DOC_MODAL";

PR.UPDATE_NOTE = "UPDATE_NOTE";
